export enum Routes {
  Home = "/",
  AboutUs = "/about-us/",
  RealisedProjects = "/realised-projects/",
  Credentials = "/credentials/",
  Blog = "/blog/",
  Career = "/career/",
  Contact = "/contact/",
  PrivacyPolicy = "/privacy-policy/",
  Offer = "/offer/",
  InvestmentWebsite = "/offer/investment-website/",
  Visualizations3D = "/offer/3d-visualizations/",
  InteriorVisualizations = "/offer/3d-visualizations-interior/",
  DeveloperWebsite = "/offer/developer-website/",
  MarketingCampaigns = "/offer/marketing-campaigns/",
  PropertyCard = "/offer/property-card/",
  Animations3D = "/offer/3d-animations/",
  Floor3DPlan = "/offer/3d-floor-plan/",
  VirtualTour = "/offer/virtual-tour/",
  ConstructionCompanyWebsite = "/offer/construction-company-website/",
  ThankYou = "/thank-you/",
  ThankYouNewsletter = "/thank-you-newsletter/",
}

export const ALL_ROUTES = [
  { key: "home", route: Routes.Home },
  { key: "offer", route: Routes.Offer },
  { key: "about-us", route: Routes.AboutUs },
  { key: "realised-projects", route: Routes.RealisedProjects },
  { key: "credentials", route: Routes.Credentials },
  { key: "blog", route: Routes.Blog },
  { key: "career", route: Routes.Career },
  { key: "contact", route: Routes.Contact },
];

export const ALL_OFFER_ROUTES = [
  { key: "visualizations", route: Routes.Visualizations3D },
  { key: "visualizations-interior", route: Routes.InteriorVisualizations },
  { key: "3d-floor-plan", route: Routes.Floor3DPlan },
  { key: "developer-website", route: Routes.DeveloperWebsite },
  {
    key: "construction-company-website",
    route: Routes.ConstructionCompanyWebsite,
  },
  { key: "marketing-campaigns", route: Routes.MarketingCampaigns },
  { key: "investment-website", route: Routes.InvestmentWebsite },
  { key: "property-card", route: Routes.PropertyCard },
  { key: "virtual-tour", route: Routes.VirtualTour },
  { key: "3d-animations", route: Routes.Animations3D },
];
